module.exports = __webpack_public_path__ + "img/td.5b571da5.svg";